module.exports = __webpack_public_path__ + "63dfd0df635b8606fd1861cb1cddaee3.png";